import Controller from "csi/action/Controller";
import FormData from "csi/action/FormData";
import def from "csi/def";
import { FormWidget } from "csi/form/Widget";
import { ViewWidget } from "csi/view/Widget";
import ActionControllerMixin from "csi/wizard/ActionControllerMixin";
import xml from "csi/xml";
import { CallMethod } from "csi/xml/CallMethod";
import declare from "dojo/_base/declare";


const PromoteSizeChartsFromStyleToShape = declare([Controller, ActionControllerMixin], {

	sizeChartFd: null,
	NODE_NAME: "Node Name",
	SUBTYPE: "Subtype",
	SHAPE_SEASONS: "ShapeSeasons",

	getFormData: function () {
		const fd = this.sizeChartFd = this.inherited<FormData>(arguments);
		fd.setNode(null);
		return fd;
	},

	_insertSubtypeField: function (view: ViewWidget) {
		const formWidget = view as FormWidget;
		formWidget.insertFieldIfNotExist(this.SUBTYPE, 1, {
			m_typeControl: def.FIELD_FILTERING_SELECT,
		});
		formWidget.setFieldDisabled(this.SUBTYPE, true);
	},

	_onCreatePopup: function (view: ViewWidget) {
		const actionId = this.sizeChartFd.m_source.m_action.m_id;
		if (actionId == "PromoteSCFromStyleToShapeSC") {
			this._insertSubtypeField(view);
		}
		this.inherited(arguments);
	},

	/**
	 * @override
	 */
	toWriterRequest: function () {
		const { sizeChartFd } = this;

		const sizeChartName = sizeChartFd.getFieldValue(this.NODE_NAME);
		const subtype = sizeChartFd.getFieldValue(this.SUBTYPE);
		const styleUrl = this.getParentURL();

		const call = this.inherited<CallMethod>(arguments);

		call.addParameter("FromStyle", xml.ATTR_STRING, styleUrl);
		call.addParameter("SizeChartName", xml.ATTR_STRING, sizeChartName);
		call.addParameter("SizeChartSubtype", xml.ATTR_STRING, subtype);

		return call;
	},

});

export = PromoteSizeChartsFromStyleToShape;